import React from 'react';
import { useFormikContext } from 'formik';
import { FormikColorPicker } from 'lib/components/formik/FormikColorPicker';
import { Gap } from 'lib/components/styles/layout';
import { ILandingPageBuilderForm } from '../../../types';
import { FormSection } from './FormSection';
import { useTheme } from 'styled-components/macro';

interface IColorSettingsProps {
  index?: number;
}

export const ColorSettings = ({ index }: IColorSettingsProps) => {
  const { values } = useFormikContext<ILandingPageBuilderForm>();
  const theme = useTheme();
  const {
    bodyBackgroundColor,
    textColor,
    buttonColor,
    headerBackgroundColor,
    footerBackgroundColor,
  } = values.uiKits?.[index || 0] || {};

  const colorPickers = [
    {
      value: bodyBackgroundColor,
      label: 'Background Color',
      name: 'bodyBackgroundColor',
    },
    { value: textColor, label: 'Text Color', name: 'textColor' },
    { value: buttonColor, label: 'Button Color', name: 'buttonColor' },
    {
      value: headerBackgroundColor,
      label: 'Header Color',
      name: 'headerBackgroundColor',
    },
    {
      value: footerBackgroundColor,
      label: 'Footer Color',
      name: 'footerBackgroundColor',
    },
  ];

  return (
    <Gap>
      <FormSection title='COLORS'>
        {colorPickers.map(({ label, name }) => (
          <FormikColorPicker
            key={name}
            label={label}
            name={`uiKits[${index}].${name}`}
            extendStyles={{
              labelStyles: {
                fontSize: '12px',
                color: theme.colors.neutral[80],
                fontWeight: 600,
                marginBottom: '8px',
              },
            }}
          />
        ))}
      </FormSection>
    </Gap>
  );
};
